export const removeUndefined = (body: any) => {
  const parsedBody: any = {};
  for (const prop of Object.keys(body)) {
    if (body[prop] !== undefined) {
      parsedBody[prop] = body[prop];
    }
  }
  return parsedBody;
};
